import { EventTicketTag } from '@skygroup/shared/utils/eventTicketTags';

// Single source of truth for the event ticket display name:
// prefer the main part of the splitted category name, then the full
// category name, then the raw ticket name.
export const getEventTicketCategoryName = (ticket: any): string | undefined =>
  ticket?.splittedCategoryName?.main || ticket?.categoryName || ticket?.name;

// Seating is provider text shown as-is; every other tag type is named after
// its sportsAndEvents translation key.
export const getEventTicketTagLabel = (
  tag: EventTicketTag,
  sportsAndEvents_t: any
): string =>
  tag.type === 'seating' ? tag.text ?? '' : sportsAndEvents_t?.[tag.type] ?? '';
